import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Complete Reference Guides', '✅ 5 Exclusive Bonus Guides FREE'], ['✅ 390+ Pages of Premium Content', '✅ Printable Resources'], ['✅ Visual Reference Charts', '✅ Correspondence Maps']];
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/ccgC2V1PfbabSz1fEgKP9Z/ChatGPT_Image_9_ago_2026,_10_00_05_p.m..png';
export function Hero() {
  return <>
      <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-110" data-mp="127ect9b6vhbc">
        <div className="mx-auto max-w-5xl text-center" data-id="element-111" data-mp="xaxfppm0hsm4">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-112" data-mp="sb1e1x0sed9q">
            ✦ Stop Searching. Start Mastering. ✦
          </motion.span>
          
          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12
        }} className="mx-auto mt-3 max-w-xl text-sm font-semibold leading-snug text-navy sm:text-base" data-id="element-113" data-mp="3j9kalakrlffl">
            Your complete professional reference library for mastering Tarot, Reiki, Chakras, Pendulum Healing, Crystals, Sacred Geometry, and more.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-114" data-mp="3599f1u8ifco3">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-115" data-mp="2vglmxcsh5wvp">
              📦 Everything You Get Instantly
            </p>
            <div className="mt-2 space-y-1 text-xs font-medium text-slate sm:text-sm" data-id="element-116" data-mp="2ll0i76w0uii9">
              {benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-5 gap-y-1" data-id="element-117" data-mp="s2tf1pz30hru">
                  {row.map(benefit => <span key={benefit} data-id="element-118" data-mp="na08qxnyt1dn">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-119" data-mp="ia5kl1vkqpwa">
            <img src={mockupUrl} alt="Energy Healing System complete reference library of 11 guides and printable charts" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-120" data-mp="161j7utevbvae" />
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-121" data-mp="x0ut1whnhqwg">
            <CTAButton href="#complete-package" pulse size="large" data-id="element-122" data-mp="1x9kugm9v74h7">
              GET INSTANT ACCESS
            </CTAButton>
            <p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-123" data-mp="21a4ohgz55rz4">
              📄 High-Quality PDF <span className="mx-1" data-id="element-124" data-mp="2697noksfx3z6">·</span> 🖨️ Printable Resources{' '}
              <span className="mx-1" data-id="element-125" data-mp="2b0zduu7op7os">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-126" data-mp="2b2sm2dxy3zyw">·</span> 🔒
              Secure Payment <span className="mx-1" data-id="element-127" data-mp="2fyr83uvsx5w5">·</span> 🛡️ 7-Day Purchase Protection
            </p>
          </motion.div>
        </div>
      </section>
      <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-128" data-mp="2l0zyqkl7bvv3">
        <div className="mx-auto max-w-3xl text-center" data-id="element-129" data-mp="2p1a53ycwooah">
          <p className="text-sm font-bold sm:text-base" data-id="element-130" data-mp="2tztte5ez2c60">
            🚀 Launch offer active — All 5 Bonus Guides FREE with purchase · Price increases when the
            timer hits zero
          </p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-131" data-mp="zkr9qocltob0">
            <div className="h-full w-[74%] rounded-full bg-amber" data-id="element-132" data-mp="4al077oyb0k7" />
          </div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-133" data-mp="3vhxglki0f9z2">74% of launch spots already claimed</p>
        </div>
      </section>
    </>;
}